import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DpadZoneType } from '@core/constants';
import { LOGOUT } from '@core/constants/text.common';
import { DialogTemplate } from '@core/models/models';

@Component({
  selector: 'caremoni-dialog-logout',
  templateUrl: './dialog-logout.component.html',
  styleUrl: './dialog-logout.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class DialogLogoutComponent implements OnInit {
  @Input() dialogTemplate: DialogTemplate = new DialogTemplate();
  @Input() isDisplayModal: boolean = false;
  @Output() closeModalHandler = new EventEmitter();
  LOGOUT = LOGOUT;
  DpadZoneType = DpadZoneType

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.dialogTemplate.style = { width: '160px', height: '70px'};
    this.dialogTemplate.isDismissableMask = true;
  }

  @HostListener('document:touchend', ['$event'])
  onTouchEnd(event: TouchEvent): void {
    if (!this.isDisplayModal) return;
    const dialogEl = this.el.nativeElement.querySelector('.p-dialog');
    if (dialogEl && !dialogEl.contains(event.target as Node)) {
      this.closeModal(false);
    }
  }

  closeModal(status: boolean){
    this.closeModalHandler.emit(status);
  }
}
